import React from 'react'
import PropTypes from 'prop-types'

import { Dots, FlyingCube, Heading } from 'Components/Blocks/_Legacy'
import { Border, Icon, Motion, Text, Wrapper } from 'Components/UI'

import { heartGlyph } from 'Assets/_Legacy/BlockchainPage/icons'

import { WHY_CARDS } from './mock'
import {
  Card,
  CardsHolder,
  Container,
  Content,
  CropContainer,
  DotsWrapper,
  IconHolder,
  TextContainer,
} from './styles'

function Why({ data }) {
  return (
    <>
      <Container>
        <CropContainer>
          <FlyingCube
            left={0}
            rotateAngle={39}
            size={[0, 0, 170, 170, 170, 170, 277]}
            top={0}
          />
        </CropContainer>

        <DotsWrapper>
          <Dots columns={9} rows={18} secondary />
        </DotsWrapper>

        <Wrapper wayPointTop>
          <Content>
            <Motion>
              <Heading
                horizontalAlign="center"
                light
                maxWidth={780}
                mb={[56, 56, 64, 64, 88]}
                mx="auto"
                subTitleText={data?.subtitleText}
                tagGlyph={heartGlyph}
                tagText={data?.overheadText}
                tagTextAs="h4"
                titleText={{
                  first: {
                    text: data?.titleTextFirst,
                    bold: data?.firstBold,
                  },
                  second: {
                    text: data?.titleTextSecond,
                    bold: data?.secondBold,
                  },
                }}
              />
              <CardsHolder>
                {WHY_CARDS.map(item => (
                  <Card key={item.id}>
                    <IconHolder mb={[0, 0, 0, 32]} mr={[20, 20, 32, 0]}>
                      <Icon glyph={item.icon} size={[24, 24, 36, 42, 46]} />
                    </IconHolder>

                    <TextContainer>
                      <Text as="h4" bold fontSize={20} mb={2} white>
                        {item.title}
                      </Text>

                      <Text fontSize={[14, 14, 14, 14, 16]} light white>
                        {item.text}
                      </Text>
                    </TextContainer>
                  </Card>
                ))}
              </CardsHolder>
            </Motion>
          </Content>
        </Wrapper>
      </Container>
      <Border bottomLeft primary />
    </>
  )
}

Why.defaultProps = {
  data: {},
}

Why.propTypes = {
  data: PropTypes.object,
}

export default Why
